import React from 'react';
import { useSelector } from "react-redux";
import PopOver from '../../../../../components/Popover/Popover';
import NotificationPopUp from '../../../../../components/Notification/NotificationPopUp';
import { AuthorizedMenu } from '../AuthorizedMenu';
import { RightMenuBox, AccountContainer, RegisterContainer, CartContainer, CartIcon, CartLabel, BadgeContainer, LabelContainer, FavoriteContainer, NotificationContainer, NotificationBadgeContainer, QRCodeContainer } from './RightMenu.style';
import {Account} from "../../../../../assets/icons/Account";
import { Basket } from "../../../../../assets/icons/Basket";
import { Notification } from '../../../../../assets/icons/Notification';
import {useCart} from "../../../../../contexts/cart/use-cart";
import t from '../../../../../i18n/translate';
import { Favorite } from '../../../../../assets/icons/Favorite';
import { CropFree } from "@material-ui/icons"
import { AppQrCode } from '../../../../../assets/icons/AppQrCode';
import QrCodeMenu from '../QrCodeMenu';

export const RightMenu = ({
  props,
  onLogout,
  avatar,
  isAuthenticated,
  onJoin
}) => {
  const {
    cartItemsCount,
    calculatePrice,
    items,
  } = useCart();

  // the sum of quantity of every item, not the sum of items itself
  const totalCartItemsCount = items.reduce((acc, item) => {
    return acc + item.quantity;
  }, 0);

  const cartType = useSelector( state => state.cartReducer.cartType );

  const handleCart = () => {
    document.getElementsByClassName("product-cart")[0].click();
    document.getElementsByClassName("product-cart")[0].style.visibility = "visible";
  }

  return (
    <RightMenuBox>
      {
        isAuthenticated &&
        <NotificationPopUp props={props} />
      }
      {isAuthenticated && document.getElementsByClassName("product-cart").length > 0 &&
	      <CartContainer className="cart-container" id="cart-icon" onClick={handleCart}>
          <CartIcon>
            <Basket cartType={cartType} />
            <BadgeContainer className={cartType}>{totalCartItemsCount}</BadgeContainer>
          </CartIcon>
          <CartLabel>
              <LabelContainer className={cartType}>${calculatePrice()}</LabelContainer>
          </CartLabel>
        </CartContainer>}
      {isAuthenticated &&
        <FavoriteContainer onClick={(e) => {
          e.preventDefault()
          window.location.href = '/favorites'
        }}>
          <Favorite />
        </FavoriteContainer>
      }

      <PopOver
        direction="right"
        className="user-pages-dropdown"
        handler={
          <QRCodeContainer style={{ position: 'unset' }}>
            <AppQrCode />
          </QRCodeContainer>
        }
        content={<QrCodeMenu cartType={cartType} />}
      />  
      
      
      {!isAuthenticated ? (
        <RegisterContainer id={"joinBTn"} onClick={onJoin}>
          <Account />
          {/* <div style={{ fontSize: "15px" }}>{t('login_title')}</div> */}
        </RegisterContainer>
      ) : (
        <PopOver
          direction="right"
          className="user-pages-dropdown"
          handler={
           <AccountContainer style={{position: 'unset'}}>
              <Account />
              {/* <div style={{ fontSize: "15px" }}>{t('home_menu_account')}</div> */}
           </AccountContainer>
          }
          content={<AuthorizedMenu onLogout={onLogout} cartType={cartType} />}
        />
      )}
    </RightMenuBox>
  );
};
